// @flow
import React, { Component, Fragment } from 'react';
import UserMenu from 'components/base/UserMenu';
import { connect } from 'react-redux';
import type { State } from 'store';
import { BaseActions } from 'store/actionCreators';
import storage, { keys } from 'lib/storage';
import { resetSession } from 'lib/tracking';
import { logout as ssoLogout } from 'lib/sso';
import UserMobileMenu from 'components/base/UserMobileMenu';

type Props = {
  visible: boolean,
  username: string,
  rule: string,
  showDrawer?: boolean,
  depositHistoryCount: number,
};

class UserMenuContainer extends Component<Props> {
  onClickOutside = e => {
    BaseActions.hideUserMenu();
  };

  onClick = () => {
    BaseActions.hideUserMenu();
  };

  onLogout = async () => {
    // Tawk 로그아웃
    if (window.Tawk_API) {
      window.Tawk_API.logout();
    }

    // 추적 세션 리셋
    resetSession();

    // 로컬 스토리지 정리
    storage.remove(keys.user);

    // SSO 로그아웃 (백엔드 로그아웃 + SSO 서버 로그아웃 리다이렉트)
    await ssoLogout();
  };

  render() {
    const { visible, username, rule, depositHistoryCount } = this.props;
    const { onClickOutside, onClick, onLogout } = this;
    if (!visible) return null;

    return (
      <UserMenu
        username={username}
        rule={rule}
        hasDepositHistory={depositHistoryCount > 0}
        onClickOutside={onClickOutside}
        onClick={onClick}
        onLogout={onLogout}
        eventTypes={['click', 'touchend']}
      />
    );
  }
}

export default connect(
  ({ base, user, deposit }: State) => ({
    visible: base.userMenu,
    username: user.user && user.user.username,
    rule: user.user && user.user.rule,
    depositHistoryCount: deposit.historyCount || 0,
  }),
  () => ({}),
)(UserMenuContainer);



// WEBPACK FOOTER //
// ./src/containers/base/UserMenuContainer.js